import axios from 'axios';

import { AUTHORIZATION } from 'src/constants';

import { Session } from 'services/session';

import { errorsStore, progressStore, sessionStore } from 'stores';

import { ResponseProcessor } from './responseProcessor';

function isAuth() {
  return !!axios.defaults.headers.common[AUTHORIZATION];
}

// request annotation
export const request = (reqArgs: { action: string; root?: string; writeError?: boolean; authOnly?: boolean }): any => {
  reqArgs = { root: 'errors', ...reqArgs, writeError: true };

  return (target: any, propertyKey: string, descriptor: any): any => {
    var oldValue = descriptor.value;
    const sessionService = new Session(sessionStore);

    descriptor.value = async function (...args: any[]) {
      try {
        // ! Remove this line when the feature is tested
        // await sessionService.refreshTokenIfNeeded();
        if (reqArgs.authOnly && !isAuth()) {
          return [false, null];
        }

        const response = await oldValue.call(this, ...args);
        new ResponseProcessor({ ...reqArgs, response } as any).process();

        return [true, response];
      } catch (e) {
        /**
         * An axios error without a response means the request never reached the API (network error, timeout, CORS).
         * Callers read response.data, so return an empty response with status 0 instead of undefined.
         * Cancelled requests and other exceptions (bugs in the service method) are handled as before.
         */
        const isNetworkError = axios.isAxiosError(e) && !e.response && !axios.isCancel(e);
        const response = isNetworkError ? { status: 0, data: {}, config: e.config || {} } : e.response;
        new ResponseProcessor({ ...reqArgs, response, error: e } as any).process();
        return [false, response];
      }
    };

    return descriptor;
  };
};

export function action(reqArgs: { action: string; minRequestTime?: number; onlyFirst?: boolean }) {
  reqArgs = { ...reqArgs };

  return function (target: any, propertyKey: string, descriptor: any): any {
    let oldValue = descriptor.value;

    descriptor.value = async function (...args: any[]) {
      const action = reqArgs.action;

      if (reqArgs.onlyFirst && progressStore.isLoading(action)) {
        return false;
      }

      progressStore.log(action, 'progress');
      errorsStore.clearError(action);
      errorsStore.clear(action);

      const requestStartTime = new Date();

      const status = await oldValue.call(this, ...args);

      let logStatus: any = 'completed';
      if (status === false || logStatus === true) {
        logStatus = !!status ? 'completed' : 'failed';
      }

      let timeProgressParams: {
        requestStartTime: Date;
        minRequestTime: number;
      } | null = null;

      if (reqArgs.minRequestTime) {
        timeProgressParams = {
          requestStartTime,
          minRequestTime: reqArgs.minRequestTime,
        };
      }

      progressStore.log(action, logStatus, timeProgressParams);
      return status;
    };

    return descriptor;
  };
}
